function register() {}

module.exports = Object.assign(register, {
  default: register,
  register: register,
  revert: function revert() {},
  __esModule: true
});